// common/components/technicalWorkScreen/TechnicalWorkScreen.tsx
import React, { useEffect } from "react";
import { MdSettings, MdRefresh } from "react-icons/md";
import styles from "./TechnicalWorkScreen.module.scss";
import { useScreenTracking } from "../../../common/hooks/useScreenTracking";

interface TechnicalWorkScreenProps {
  message?: string;
  onRetry?: () => void;
}

export const TechnicalWorkScreen: React.FC<TechnicalWorkScreenProps> = ({
  message = "Становимся лучше для вас. Зайдите позже.",
  onRetry,
}) => {
 const { trackTechnicalWork } = useScreenTracking();

  useEffect(() => {
    trackTechnicalWork();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <MdSettings className={styles.icon} />
        <h1 className={styles.title}>Технические работы</h1>
        <p className={styles.message}>{message}</p>
        {onRetry && (
          <button className={styles.retryButton} onClick={onRetry}>
            <MdRefresh size={20} />
            <span>Обновить</span>
          </button>
        )}
      </div>
    </div>
  );
};